import React, { useEffect, useRef, useState } from "react";
import styles from "./CustomSelect.module.css";
import { ColorDictionary } from "../../Constants";

const CustomColorSelect = ({
  colorSelection,
  customId,
  customStyle,
  colorSelected,
  contextUpdater,
}) => {
  const [selectedColor, setSelectedColor] = useState(colorSelection[0]);
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);
  useEffect(() => {
    setSelectedColor(colorSelected);
  }, [colorSelected]);
  const handleColorSelect = (color) => {
    setSelectedColor(color);
    contextUpdater(customId, color);
    setIsOpen(false);
  };
  const dropdownRef = useRef(null);

  // Close the dropdown if clicked outside
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  // Use useEffect to add/remove the click event listener
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div
      className={` ${styles["custom-dropdown"]}`}
      style={customStyle}
      ref={dropdownRef}
    >
      <div
        className={styles["dropdown-header"]}
        onClick={toggleDropdown}
        onAbort={() => setIsOpen(false)}
      >
        <span
          style={{
            display: "inline-block",
            width: "20px",
            height: "20px",
            backgroundColor: ColorDictionary[selectedColor] || selectedColor,
            selectedColor,
            border: "1px solid black",
            marginRight: "10px",
          }}
        ></span>
        {selectedColor}
      </div>
      {isOpen && (
        <div className={styles["dropdown-list"]}>
          {colorSelection.map((color) => (
            <div
              key={color}
              className={styles["dropdown-item"]}
              onClick={() => handleColorSelect(color)}
            >
              <span
                style={{
                  zIndex: 1001,
                  position: "relative",
                  display: "block",
                  width: "20px",
                  height: "20px",
                  border: "1px solid black",

                  backgroundColor: ColorDictionary[color] || color,
                  marginRight: "10px",
                }}
              ></span>
              {color}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomColorSelect;
